import { BaseDialog } from "@/lib/Components/Dialog/BaseDialog";
import { GenericForm } from "@/lib/Components/Form/Forms/GenericForm";
import { CurrencyInput } from "@/lib/Components/Form/Inputs/CurrencyInput";
import { CreateBookingPaymentRequestInput, Currency } from "@/gql/graphql";
import { useDialogState } from "@/lib/Components/Dialog/Hooks/useDialogState";
import { DialogSubmitButton } from "@/lib/Components/Dialog/Components/DialogSubmitButton";
import { useGqlMutation } from "@/lib/GraphQLCodegen/fetcher";
import { createBookingPaymentRequestMutation } from "@/app/Bookings/GraphQL/bookingPaymentRequestMutations";
import { BookingRecord } from "@/app/Bookings/GraphQL/bookingRecordQuery";
import { TextAreaInput } from "@/lib/Components/Form/Inputs/TextAreaInput";
import { z } from "zod";
import { toFormikValidationSchema } from "@/lib/Zod/zod-formik-adapter";

type BookingRequestPaymentDialogProps = {
  booking: BookingRecord;
};

const paymentRequestValidation = z.object({
  description: z.string().min(3).max(255),
  amount: z.number().min(1),
  currency: z.enum(Currency),
});
export function BookingPaymentRequestCreateDialog({
  booking,
}: BookingRequestPaymentDialogProps) {
  const { mutateAsync } = useGqlMutation(createBookingPaymentRequestMutation);
  const { close } = useDialogState();

  return (
    <BaseDialog title="Request payment">
      <GenericForm<CreateBookingPaymentRequestInput>
        initialValues={{
          booking: {
            connect: booking.id,
          },
          amount: null!,
          currency: booking.currency,
          description: null!,
        }}
        validationSchema={toFormikValidationSchema(paymentRequestValidation)}
        onSubmit={async (values) => {
          await mutateAsync({
            input: values,
          });
          close();
        }}
      >
        <CurrencyInput
          currency={booking.currency}
          name={"amount"}
          label={"Amount"}
        />

        <TextAreaInput
          name={"description"}
          label={"Description"}
          className="col-span-full"
          textAreaProps={{
            maxLength: 255,
          }}
        />
        <DialogSubmitButton text={"Request payment"} />
      </GenericForm>
    </BaseDialog>
  );
}
